







import Vue from 'vue';
import { AxiosError, AxiosResponse } from 'axios';

import Loader from '@/components/Loader.vue';

import OrderAPI from '@/services/OrderAPI.ts';
import ItemAPI from '@/services/ItemAPI';

declare global {
    interface Window {
        paypal: any;
    }
}

export default Vue.extend({
    name: 'PayPalButton',

    components: {
        Loader
    },

    props: {
        value: Boolean,
        orderId: {
            type: String,
            required: true,
            default: ''
        }
    },

    data() {
        return {
            isLoading: false
        };
    },

    created() {
        this.getPayPalSdk();
    },

    methods: {
        getPayPalSdk() {
            const script = document.createElement('script');
            script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PAYPAL_CLIENT_ID}&currency=${process.env.VUE_APP_PAYPAL_CURRENCY_CODE}`;
            script.addEventListener('load', this.setLoaded);
            document.body.appendChild(script);
        },

        setLoaded() {
            const self = this;
            window.paypal.Buttons({
                style: {
                    layout:  'vertical',
                    color:   'gold',
                    shape:   'pill',
                    label:   'paypal'
                },

                createOrder(data: any, actions: any) {
                    return OrderAPI.completePaymentPayPal(self.orderId)
                        .then((response: AxiosResponse) => {
                            return  response.data.payPalId;
                        });
                },

                onApprove(data: any, actions: any) {
                    self.isLoading = true;
                    return OrderAPI.validatePaymentPayPal(self.orderId)
                        .then((response: AxiosResponse) => {
                            self.$store.commit('setOrder', {});
                            self.$emit('input', true);
                            window.scrollTo(0, 0);
                            self.loadItems();
                        })
                        .finally(() => self.isLoading = false);
                }
            })
            .render(this.$refs.paypal);
        },

        loadItems(): void {
            ItemAPI
                .getItems()
                .then((axiosResponse: AxiosResponse) => this.$store.commit('setItems', axiosResponse.data))
                .catch((error: AxiosError) => error);
        },
    }
});
